import React from 'react';

const PreLoader = () => {
  return <div className='preloader' />;
};

export default PreLoader;
